import React from 'react';

import Panel from '@components/smartAdminUI/Panel';
import CreaWebformsWidget from '@components/widget/CreaWebformsWidget';

const CREAWEBForms = () => (
  <>
    <div className="subheader">
      <h1 className="subheader-title">
        <i className="subheader-icon fad fa-chevron-right mr-2" />
        CREA
        <span className="fw-300 ml-2 mr-2">WEBForms®</span>
      </h1>
    </div>
    <div className="row">
      <div className="col-lg-4 d-flex">
        <Panel customClass="w-100">
          <CreaWebformsWidget />
        </Panel>
      </div>
    </div>
  </>
);

export default CREAWEBForms;
